import { SSH_KEYS } from "../../actions/actionConstants.js";
import { ENDPOINTS } from "../../../constants/api.js";

export const createSSHKey = (user, sshKey) => {
  return {
    type: SSH_KEYS.POST,
    payload: {
      ...sshKey,
      user,
      endpoint: ENDPOINTS.SSH_KEYS
    }
  };
};

export default {};
